import type { AssetInventoryGroup } from '@/hooks/useAssetInventory';

const normalize = (value: string | null | undefined): string => value?.trim().toLowerCase() ?? '';

const getTopLevelLocation = (row: AssetInventoryGroup): string => {
  const source = row.location_path || row.location_name || '';
  const [topLevel] = source.split('>');
  return normalize(topLevel);
};

const getLocationPriority = (row: AssetInventoryGroup): number => {
  const topLevel = getTopLevelLocation(row);
  if (topLevel.includes('warehouse')) return 0;
  if (topLevel.includes('storefront')) return 1;
  return 2;
};

const compareText = (left: string | null | undefined, right: string | null | undefined): number =>
  normalize(left).localeCompare(normalize(right));

export const sortTransferInventoryRows = (rows: AssetInventoryGroup[]): AssetInventoryGroup[] => {
  return [...rows].sort((left, right) => {
    const assetNameOrder = compareText(left.asset_name, right.asset_name);
    if (assetNameOrder !== 0) return assetNameOrder;

    const linOrder = compareText(left.lin, right.lin);
    if (linOrder !== 0) return linOrder;

    const nsnOrder = compareText(left.nsn, right.nsn);
    if (nsnOrder !== 0) return nsnOrder;

    const locationPriorityOrder = getLocationPriority(left) - getLocationPriority(right);
    if (locationPriorityOrder !== 0) return locationPriorityOrder;

    const locationPathOrder = compareText(left.location_path, right.location_path);
    if (locationPathOrder !== 0) return locationPathOrder;

    const locationNameOrder = compareText(left.location_name, right.location_name);
    if (locationNameOrder !== 0) return locationNameOrder;

    return compareText(left.id, right.id);
  });
};
